// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-scrollbar {
    width: 0 !important;
}

.card {
    width: 100%;
    padding-bottom: 0 !important;
    background-color: #F5F5F5;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
    min-height: 100%;
    height: auto;
    transition: box-shadow 0.3s ease;
}

.card:hover {
    cursor: grab;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
}

.form-control {
    border: none;
    color: black;
    background-color: rgb(251, 230, 201);
}


.card .containerImg {
    width: 100%;
    height: 245px;
    overflow: hidden;
    border-radius: 7px 7px 40px 0px;
    -webkit-border-radius: 7px 7px 40px 0px;
    -moz-border-radius: 7px 7px 40px 0px;
    -ms-border-radius: 7px 7px 40px 0px;
    -o-border-radius: 7px 7px 40px 0px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    position: relative;
}

.card .containerImg p {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f09502c4;
    color: white;
    border: 1px solid white;
    padding: 4px 10px;
    border-radius: 7px 0 7px 0;
    -webkit-border-radius: 7px 0 7px 0;
    -moz-border-radius: 7px 0 7px 0;
    -ms-border-radius: 7px 0 7px 0;
    -o-border-radius: 7px 0 7px 0;
}

.card .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 2%;
}

.card .title>img {
    width: 32%;
    height: auto;
    margin-right: 25px;
}

.card .title>div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;
}

.card .title>div p {
    width: 100%;
    margin-bottom: 0;
}

.card .title>div p:first-child {
    margin-bottom: 10px;
    font-size: 1rem;
}

.card .title .estado {
    color: white;
    padding: 3px 15px;
    width: auto !important;
}

.card-body .pdata {
    width: 100%;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.card-body .pdata>div {
    width: 50%;
}

.card-body .pdata>div:last-child {
    text-align: right;
}

/* Estilos para "Gestionando Inversiones" */
.status-container {
    position: relative;
}

.gestionando-inversiones {
    display: block;
    margin-top: 5px; /* Ajusta la distancia entre "Activo" y "Gestionando Inversiones" */
    color: #848484;
    font-size: 12.6px;
    text-align: center;
}

.pdatas {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
}

.dataTransferencia {
    background: #EDEDED;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    padding: 0px 0px 50px 40px;
}


.pdata1,
.pdata2,
.pdata3 {
    width: 33%;
    display: flex !important;
    justify-content: center;
    align-items: space-around;
    flex-wrap: wrap;
    padding: 4px;
    text-align: center;
}

.pdata1,
.pdata2 {
    border-right: 1px solid gray;
}

.pdata1 {
    padding-left: 0;
}

.pdata3 {
    padding-right: 0;
}

.modalDetail1 .modal-content1 {
    background-color: #181b25;
}

.modalDetail1 .modal-content1>* {
    width: 80%;
    margin: 0 auto;
}

.modal-header {
    border-bottom: 2px solid #f09502;
}

.card .containerButtons {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: stretch;
}

.card .containerButtons button {
    width: 48%;
    margin-bottom: 0 !important;
}

/* Cuando el botón tiene la clase w-100, asegurarse que ocupe todo el ancho */
.card .containerButtons button.w-100 {
    width: 100% !important;
}

.buyform {
    margin: 10px 10px 35px 80px;
}

.buyform .cost {
    background-color: #0d0d0d;
    padding: 15px;
    font-size: 1rem;
}

.buyform button {
    min-width: 60%;
    background-color: #0D0D0E !important;
    color: white;
}

.dataSale {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    flex-wrap: wrap;
}

.dataSale>div {
    border: 1px solid #f09502;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dataSale .logoPolyscan {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid;
    padding: 8px;
    margin-right: auto;
    min-width: 70%;
}

.dataSale .logoPolyscan:hover {
    cursor: pointer;
}

.dataSale .logoPolyscan img {
    max-width: 40px;
    height: auto;
    margin-right: 5px;
}

.dataSale .email {
    min-width: 70%;
}

.dataSale>div:first-child {
    width: 40%;
}

.dataSale>div span {
    font-weight: bold;
    font-size: 1rem;
}

.dataSale>div:last-child {
    width: 59%;
}

.dataSale .title {
    font-size: 1.3rem;
    margin-bottom: 18px;
    font-weight: bold;
    color: #f09502;
}

.dataSale>div:first-child p:last-child {
    margin-bottom: 0 !important;
}

.dataSale a {
    display: flex;
    justify-content: center;
    width: 100%;
    text-decoration: none;
}

.dataDisplay {
    display: flex;
    gap: 60px;
    margin-top: 2rem;
}


@media (max-width: 1600px) {
    .card .containerImg {
        height: 190px;
    }
}

@media (max-width: 1400px) {
    .navMargin {
        margin-top: 3rem !important;
    }

    .cardContainer {
        margin-top: 1rem !important;
    }

    .sizeTitle {
        font-size: 15px !important;
    }


}

@media (max-width: 1235px) {
    .popularBlockchain {
        padding: 0 !important;
        top: -40px !important;
        ;
        left: calc(50% - 60px) !important;
    }
}


@media (max-width: 995px) {
    .popularBlockchain {
        padding: 2px 10px 0px 10px !important;
        top: -22px !important;
        left: calc(50% - 68px) !important;
    }

    .infoCardModal{
        display: none!important;
    }

    .cardImageModal {
          border: none!important;
          padding: 10px 15px 10px 15px;
          background-color: transparent!important;
      }

    .cardImageContainerModal{
        border-radius: 0px!important;
    }
}

@media (max-width: 820px) {
    .popularBlockchain {
        padding: 0 !important;
        left: calc(50% - 60px) !important;
    }
}

@media (max-width: 720px) {
    .popularBlockchain {
        top: -40px !important;
        ;
    }
}

@media (max-width: 656px) {
    .buyform {
        margin: 20px!important;
        margin-left: calc(15% - 30px) !important;
    }

    .cardContainer {
        margin-top: 2rem !important;
        padding-left: 10px !important;
        padding-right: 0 !important;
        margin-bottom: 2rem !important;
    }

    .circle {
        display: none;
    }

    .card-body {
        padding: 10px;
    }

    .modalDetail .modal-content>*,
    .modalDetail2 .modal-content>* {
        width: 103%;
    }

    .buyform button {
        width: 100%;
    }

    .pdata1,
    .pdata2,
    .pdata3 {
        padding: 5px;
    }

    .pdata1 p:first-child,
    .pdata2 p:first-child,
    .pdata3 p:first-child {
        font-size: .7rem;
    }

    .dataSale>div:first-child {
        width: 100%;
        padding: 0 !important;
        margin-bottom: 35px;
        padding-bottom: 35px !important;
        border-bottom: 1px solid #8282828f !important;
    }

    .dataSale>div:last-child {
        width: 100%;
        padding: 0 !important;
        border: none;
    }

    .priceData {
        flex-direction: column;
        margin: 2rem !important;
    }

    .containerBox {
        flex-direction: column;
        /*gap: 20px;*/
    }

    .specialBox{
        margin-top: 1rem !important;
    }

    .titulo-movil{
        font-size: 1rem !important;
        margin-top: 1rem;
    }

    .movil-nav{
        margin-top: -2rem !important;
    }

    .movil-options{
        margin-top: -1rem !important;
    }

    .nav {
        display: flex;
        flex-direction: column;
    }

    .navMargin {
        margin: 0 !important;
    }

    .dataTransferencia {
        padding: 0px 0px 50px 20px;
    }

    .box {
        flex-basis: 100% !important;
        /* Las cajas ocuparán todo el ancho en pantallas más pequeñas */
        max-width: 100% !important;
        /* Límite de ancho máximo de las cajas */
    }

    .terms {
        margin-left: 0 !important;
    }

    .buttonflex {
        margin-left: 0 !important;
    }

    .marginCantitad {
        margin-left: 0 !important;
    }

    .popularBlockchain {
        padding: 2px 10px 0px 10px !important;
        top: -22px !important;
        left: calc(50% - 68px) !important;
    }

    select {
        margin-bottom: 10px;
    }

    .dataTransferencia {
        padding: 0px 0px 50px 5px;
    }

    .iban {
        padding-top: 23px;
    }

    .dataDisplay{
        gap: 20px;
    }

    .form-control{
        font-size: 11px;
    }

    .cardImageContainerModal{
        width: 100%;
        padding-bottom: 0 !important;
        background-color: #F5F5F5;
        border: 3px solid #f09502;
        margin-bottom: 30px;
        border-radius: 15px !important;
    }

    .no-mobile {
        display: none !important;
    }

    h5{
        font-size: 0.85rem !important;
    }

    .popular{
        left: calc(50% - 50px) !important;
    }
}

@media (min-width: 656px) {
    .options-mobile{
        display: none
    }
}



.flexContainer {
    display: flex;
}

.colorDark {
    background-color: #181b25;
}

.colorWhite {
    background-color: white;
}

.paddingModalBody {
    padding: 0 !important;
}

.cardContainer {
    margin-top: 4rem;
    padding-left: 3rem;
    padding-right: 3rem;
}

.btnClose {
    background-color: transparent;
    color: white;
    border: none;
    font-size: 15px;
}

.btnContainer {
    margin-top: 2rem;
}

mdb-tab {
    color: black !important;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #FF9600;
    border: none;
    border-bottom: 1px solid;
}

.nav-link {
    color: black;
    border: none;
    font-weight: bold;
    cursor: pointer;
}

.dai {
    display: flex;
    align-items: center;
    gap: 5px;
}

.iQuestion {
    color: gray;
    font-size: 24px;
    margin-top: -4px;
}

p,
label {
    color: #848484;
}

.marginCantitad {
    display: flex;
    gap: 15px;
    margin-left: -2.3rem;
}

.priceData {
    display: flex;
    justify-content: space-between;
    margin: 10px 120px 10px 85px;
}

.containerBox {
    display: flex;
    flex-wrap: wrap;
    /* Permite que los elementos se envuelvan cuando no haya suficiente espacio en una línea */
}

.box {
    border: 3px solid #FF9600;
    padding: 5px 5px 5px 5px;
    margin-right: 15px;
    margin-bottom: 15px;
    cursor: pointer;
    border-radius: 20px;
    max-width: 250px;
    position: relative;
    flex: 1;
}

.box.active {
    background-color: rgba(255, 150, 0, 0.2);
}


.popular {
    position: absolute;
    border: 3px solid #FF9600;
    background: white;
    border-radius: 25px;
    padding: 2px 10px 0px 10px;
    top: -24px;
    left: calc(50% - 68px);
}

.divPersonalizar {
    display: flex;
    align-items: center;
}

.personalizar {
    color: black;
    text-decoration: underline;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}


.form-control:focus {
    outline-color: #FF9600;
}

.navMargin {
    margin: 70px 10px 30px 80px;
    margin-top: 7rem;
}


.tool {
    cursor: help;
    position: relative;
}

.tool::before,
.tool::after {
    top: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
    opacity: 1;
    transform: scale(1) translateX(0);
    z-index: 100;
    margin-left: 1rem;
}

.tool:hover::before,
.tool:focus::before {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
}

.tool::after {
    background: #3E474F;
    border-radius: .25em;
    color: #EDEFF0;
    content: attr(data-tip);
    margin-top: -2.5em;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateX(50%);
    width: 20em;
}

.tool:hover::after,
.tool:focus::after {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
}

@media (max-width: 1060px) {
    .tool::after {
        font-size: .95em;
        margin-top: -15.5em;
        width: 28em;
        right: 27%;
        margin-top: -2px;
        transform: translate(-50%, -50%);
    }
}

@media (max-width: 760px) {
    .tool::after {
        font-size: .75em;
    }
}



/*tooltip Box*/
.con-tooltip {
    position: relative;
    display: inline-block;
    cursor: help;

}

/*tooltip */
.tooltip {
    visibility: hidden;
    z-index: 1;
    position: absolute;
    top: -140%;
    left: -25%;
    background: #3E474F;
    border-radius: .25em;
    color: #EDEFF0;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateX(50%);
    width: 20em;
}



.con-tooltip:hover .tooltip {
    visibility: visible;
    transform: translateY(-10px);
    opacity: 1;
}


.right .tooltip {
    top: 150%;
    left: -800%;
}

.right .tooltip::after {
    top: 150%;
    left: -800%;
    transform: rotate(90deg);
}

.circle {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background: #292929;
    color: white;
}

.terms {
    display: flex;
    gap: 10px;
    margin-left: -2.2rem;
}


.buttonflex {
    display: flex;
    gap: 10px;
    margin-left: -2.2rem;
    margin-top: 1rem;
    align-items: center;
}

.popularBlockchain {
    position: absolute;
    border: 3px solid #FF9600;
    background: white;
    border-radius: 25px;
    padding: 2px 10px 0px 10px;
    top: -22px;
    left: calc(50% - 68px);
}

.sizeTitle {
    font-weight: 600;
}


select {
    border: 1px solid white !important;
}

@media screen and (max-width: 600px) {
    #amountBuyTransferencia::placeholder {
      font-size: 9px;
    }
  }

  .header-modal-wallet{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: #FF9600;
    font-size: 19px;
    color: white;
    border-radius: 50px;
    padding: 8px;
  }

  /* Ocultar la wallet completa en dispositivos móviles */
@media (max-width: 768px) {
    .full-wallet {
      display: none;
    }
    .short-wallet {
      display: inline;
    }
    .header-modal-wallet{
      font-size: 13px;
    }
  }

  /* Mostrar la wallet completa en dispositivos de escritorio */
  @media (min-width: 769px) {
    .full-wallet {
      display: inline;
    }
    .short-wallet {
      display: none;
    }
  }

  @media (max-width: 1450px) and (min-width: 500px) {
    .small-text {
      font-size: 0.85rem !important; /* Ajusta el tamaño según tus necesidades */
    }
  }

.progress-bar {
  background: linear-gradient(90deg, #ff9500 0%, #ffb84d 100%) !important;
  border-radius: 20px;
}

/* Nuevos estilos para el diseño actualizado */
.project-header {
  width: 100%;
}

.project-title {
  font-size: 1.35rem !important;
  font-weight: 600 !important;
  color: #000 !important;
  margin: 0 !important;
  margin-bottom: 12px !important;
  line-height: 1.2 !important;
}

/* Selectores más específicos para sobrescribir Bootstrap h2 */
.card .card-body .project-title,
.card .project-header .project-title,
.card .project-header h2.project-title,
.card-body .project-header h2.project-title {
  font-size: 1.35rem !important;
  font-weight: 600 !important;
  margin-bottom: 12px !important;
}

.project-address {
  font-size: 0.95rem;
  color: #000;
  margin: 0;
}

.project-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.badge-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.badge-type {
  background: linear-gradient(to right, #ccffd7 0%, #e8f8ed 100%);
  color: #000;
}

.badge-code {
  background-color: #e0e0e0;
  color: #000;
}

/* Nuevo formato de financiación */
.pdata-new {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.finance-label {
  font-size: 0.85rem;
  color: #666;
  margin: 0 0 4px 0;
}

.finance-amount {
  font-size: 1.1rem;
  font-weight: 600;
  color: #000;
  margin: 0;
}

/* Detalles del proyecto */
.project-details {
  width: 100%;
}

.detail-item {
  font-size: 0.95rem;
  color: #000;
  margin: 0 0 8px 0;
}

.detail-value {
  font-weight: bold;
}

/* Badge de estado en la imagen */
.status-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  color: white;
  z-index: 10;
}

.badge-venta-privada {
  background-color: #a2cb6c;
}

.badge-en-estudio {
  background-color: #FA629C;
}

.badge-gestionando {
  background-color: #a2cb6c;
}

.badge-activo {
  background-color: #a2cb6c;
}

.badge-financiado {
  background-color: #848484;
}

.badge-en-curso {
  background-color: #6941C6 !important;
}

.badge-dividendos {
  background-color: #6EC8CA;
}

.badge-vendido {
  background-color: #0093A2;
}

/* Botones nuevos */
.btn-invest {
  background: linear-gradient(to right, #fea11b 0%, #ffc266 100%);
  color: white;
  border: none;
  border-radius: 25px;
  padding: 6px 20px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.btn-invest:hover:not(:disabled) {
  background: linear-gradient(to right, #fea11b 0%, #ffc266 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(254, 161, 27, 0.3);
}

.btn-invest:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-know-more {
  background: linear-gradient(to right, #d1c7c6 0%, #d5cdcc 100%);
  color: white;
  border: none;
  border-radius: 25px;
  padding: 6px 20px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.btn-know-more:hover:not(:disabled) {
  background: linear-gradient(to right, #c4b8b7 0%, #c8c0bf 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-know-more:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Ajustes para el contenedor de botones */
.containerButtons {
  display: flex;
  gap: 12px;
  width: 100%;
}

.containerButtons .btn {
  flex: 1;
  margin-bottom: 0 !important;
}

.containerButtons .btn.w-100 {
  flex: 1 1 100%;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/card-real-estate/card-real-estate.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,yEAAyE;IACzE,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,yEAAyE;AAC7E;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oCAAoC;AACxC;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,+BAA+B;IAC/B,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,wEAAwE;IACxE,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe,EAAE,mEAAmE;IACpF,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,0BAA0B;AAC9B;;;AAGA;;;IAGI,UAAU;IACV,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA,6EAA6E;AAC7E;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;;AAGJ;;AAEA;IACI;QACI,qBAAqB;QACrB,qBAAqB;;QAErB,iCAAiC;IACrC;AACJ;;;AAGA;IACI;QACI,qCAAqC;QACrC,qBAAqB;QACrB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;UACM,sBAAsB;UACtB,4BAA4B;UAC5B,uCAAuC;MAC3C;;IAEF;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,qBAAqB;;IAEzB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,wCAAwC;IAC5C;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;QAC7B,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;;QAGI,YAAY;IAChB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,+BAA+B;QAC/B,6CAA6C;IACjD;;IAEA;QACI,WAAW;QACX,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,+DAA+D;QAC/D,0BAA0B;QAC1B,wCAAwC;IAC5C;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,qCAAqC;QACrC,qBAAqB;QACrB,iCAAiC;IACrC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,4BAA4B;QAC5B,yBAAyB;QACzB,yBAAyB;QACzB,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;;;AAIA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,0FAA0F;AAC9F;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;;;IAII,UAAU;IACV,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4DAA4D;IAC5D,oCAAoC;IACpC,WAAW;AACf;;AAEA;;IAEI,wDAAwD;AAC5D;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;;AAIA,cAAc;AACd;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;;AAEhB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,4DAA4D;IAC5D,oCAAoC;IACpC,WAAW;AACf;;;;AAIA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,UAAU;AACd;;;AAGA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAS;IACT,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kCAAkC;AACtC;;AAEA;IACI;MACE,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,YAAY;EACd;;EAEA,uDAAuD;AACzD;IACI;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;;EAEA,6DAA6D;EAC7D;IACE;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,6BAA6B,EAAE,2CAA2C;IAC5E;EACF;;AAEF;EACE,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;;;;EAIE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,+DAA+D;EAC/D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+DAA+D;EAC/D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+DAA+D;EAC/D,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["*::-webkit-scrollbar {\n    width: 0 !important;\n}\n\n.card {\n    width: 100%;\n    padding-bottom: 0 !important;\n    background-color: #F5F5F5;\n    border: 1px solid #e0e0e0;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);\n    min-height: 100%;\n    height: auto;\n    transition: box-shadow 0.3s ease;\n}\n\n.card:hover {\n    cursor: grab;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);\n}\n\n.form-control {\n    border: none;\n    color: black;\n    background-color: rgb(251, 230, 201);\n}\n\n\n.card .containerImg {\n    width: 100%;\n    height: 245px;\n    overflow: hidden;\n    border-radius: 7px 7px 40px 0px;\n    -webkit-border-radius: 7px 7px 40px 0px;\n    -moz-border-radius: 7px 7px 40px 0px;\n    -ms-border-radius: 7px 7px 40px 0px;\n    -o-border-radius: 7px 7px 40px 0px;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n    position: relative;\n}\n\n.card .containerImg p {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #f09502c4;\n    color: white;\n    border: 1px solid white;\n    padding: 4px 10px;\n    border-radius: 7px 0 7px 0;\n    -webkit-border-radius: 7px 0 7px 0;\n    -moz-border-radius: 7px 0 7px 0;\n    -ms-border-radius: 7px 0 7px 0;\n    -o-border-radius: 7px 0 7px 0;\n}\n\n.card .title {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 2%;\n}\n\n.card .title>img {\n    width: 32%;\n    height: auto;\n    margin-right: 25px;\n}\n\n.card .title>div {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    flex-wrap: wrap;\n}\n\n.card .title>div p {\n    width: 100%;\n    margin-bottom: 0;\n}\n\n.card .title>div p:first-child {\n    margin-bottom: 10px;\n    font-size: 1rem;\n}\n\n.card .title .estado {\n    color: white;\n    padding: 3px 15px;\n    width: auto !important;\n}\n\n.card-body .pdata {\n    width: 100%;\n    display: flex !important;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.card-body .pdata>div {\n    width: 50%;\n}\n\n.card-body .pdata>div:last-child {\n    text-align: right;\n}\n\n/* Estilos para \"Gestionando Inversiones\" */\n.status-container {\n    position: relative;\n}\n\n.gestionando-inversiones {\n    display: block;\n    margin-top: 5px; /* Ajusta la distancia entre \"Activo\" y \"Gestionando Inversiones\" */\n    color: #848484;\n    font-size: 12.6px;\n    text-align: center;\n}\n\n.pdatas {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: stretch;\n}\n\n.dataTransferencia {\n    background: #EDEDED;\n    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 15px;\n    padding: 0px 0px 50px 40px;\n}\n\n\n.pdata1,\n.pdata2,\n.pdata3 {\n    width: 33%;\n    display: flex !important;\n    justify-content: center;\n    align-items: space-around;\n    flex-wrap: wrap;\n    padding: 4px;\n    text-align: center;\n}\n\n.pdata1,\n.pdata2 {\n    border-right: 1px solid gray;\n}\n\n.pdata1 {\n    padding-left: 0;\n}\n\n.pdata3 {\n    padding-right: 0;\n}\n\n.modalDetail1 .modal-content1 {\n    background-color: #181b25;\n}\n\n.modalDetail1 .modal-content1>* {\n    width: 80%;\n    margin: 0 auto;\n}\n\n.modal-header {\n    border-bottom: 2px solid #f09502;\n}\n\n.card .containerButtons {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    align-items: stretch;\n}\n\n.card .containerButtons button {\n    width: 48%;\n    margin-bottom: 0 !important;\n}\n\n/* Cuando el botón tiene la clase w-100, asegurarse que ocupe todo el ancho */\n.card .containerButtons button.w-100 {\n    width: 100% !important;\n}\n\n.buyform {\n    margin: 10px 10px 35px 80px;\n}\n\n.buyform .cost {\n    background-color: #0d0d0d;\n    padding: 15px;\n    font-size: 1rem;\n}\n\n.buyform button {\n    min-width: 60%;\n    background-color: #0D0D0E !important;\n    color: white;\n}\n\n.dataSale {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n    align-items: stretch;\n    flex-wrap: wrap;\n}\n\n.dataSale>div {\n    border: 1px solid #f09502;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.dataSale .logoPolyscan {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    border: 1px solid;\n    padding: 8px;\n    margin-right: auto;\n    min-width: 70%;\n}\n\n.dataSale .logoPolyscan:hover {\n    cursor: pointer;\n}\n\n.dataSale .logoPolyscan img {\n    max-width: 40px;\n    height: auto;\n    margin-right: 5px;\n}\n\n.dataSale .email {\n    min-width: 70%;\n}\n\n.dataSale>div:first-child {\n    width: 40%;\n}\n\n.dataSale>div span {\n    font-weight: bold;\n    font-size: 1rem;\n}\n\n.dataSale>div:last-child {\n    width: 59%;\n}\n\n.dataSale .title {\n    font-size: 1.3rem;\n    margin-bottom: 18px;\n    font-weight: bold;\n    color: #f09502;\n}\n\n.dataSale>div:first-child p:last-child {\n    margin-bottom: 0 !important;\n}\n\n.dataSale a {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    text-decoration: none;\n}\n\n.dataDisplay {\n    display: flex;\n    gap: 60px;\n    margin-top: 2rem;\n}\n\n\n@media (max-width: 1600px) {\n    .card .containerImg {\n        height: 190px;\n    }\n}\n\n@media (max-width: 1400px) {\n    .navMargin {\n        margin-top: 3rem !important;\n    }\n\n    .cardContainer {\n        margin-top: 1rem !important;\n    }\n\n    .sizeTitle {\n        font-size: 15px !important;\n    }\n\n\n}\n\n@media (max-width: 1235px) {\n    .popularBlockchain {\n        padding: 0 !important;\n        top: -40px !important;\n        ;\n        left: calc(50% - 60px) !important;\n    }\n}\n\n\n@media (max-width: 995px) {\n    .popularBlockchain {\n        padding: 2px 10px 0px 10px !important;\n        top: -22px !important;\n        left: calc(50% - 68px) !important;\n    }\n\n    .infoCardModal{\n        display: none!important;\n    }\n\n    .cardImageModal {\n          border: none!important;\n          padding: 10px 15px 10px 15px;\n          background-color: transparent!important;\n      }\n\n    .cardImageContainerModal{\n        border-radius: 0px!important;\n    }\n}\n\n@media (max-width: 820px) {\n    .popularBlockchain {\n        padding: 0 !important;\n        left: calc(50% - 60px) !important;\n    }\n}\n\n@media (max-width: 720px) {\n    .popularBlockchain {\n        top: -40px !important;\n        ;\n    }\n}\n\n@media (max-width: 656px) {\n    .buyform {\n        margin: 20px!important;\n        margin-left: calc(15% - 30px) !important;\n    }\n\n    .cardContainer {\n        margin-top: 2rem !important;\n        padding-left: 10px !important;\n        padding-right: 0 !important;\n        margin-bottom: 2rem !important;\n    }\n\n    .circle {\n        display: none;\n    }\n\n    .card-body {\n        padding: 10px;\n    }\n\n    .modalDetail .modal-content>*,\n    .modalDetail2 .modal-content>* {\n        width: 103%;\n    }\n\n    .buyform button {\n        width: 100%;\n    }\n\n    .pdata1,\n    .pdata2,\n    .pdata3 {\n        padding: 5px;\n    }\n\n    .pdata1 p:first-child,\n    .pdata2 p:first-child,\n    .pdata3 p:first-child {\n        font-size: .7rem;\n    }\n\n    .dataSale>div:first-child {\n        width: 100%;\n        padding: 0 !important;\n        margin-bottom: 35px;\n        padding-bottom: 35px !important;\n        border-bottom: 1px solid #8282828f !important;\n    }\n\n    .dataSale>div:last-child {\n        width: 100%;\n        padding: 0 !important;\n        border: none;\n    }\n\n    .priceData {\n        flex-direction: column;\n        margin: 2rem !important;\n    }\n\n    .containerBox {\n        flex-direction: column;\n        /*gap: 20px;*/\n    }\n\n    .specialBox{\n        margin-top: 1rem !important;\n    }\n\n    .titulo-movil{\n        font-size: 1rem !important;\n        margin-top: 1rem;\n    }\n\n    .movil-nav{\n        margin-top: -2rem !important;\n    }\n\n    .movil-options{\n        margin-top: -1rem !important;\n    }\n\n    .nav {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .navMargin {\n        margin: 0 !important;\n    }\n\n    .dataTransferencia {\n        padding: 0px 0px 50px 20px;\n    }\n\n    .box {\n        flex-basis: 100% !important;\n        /* Las cajas ocuparán todo el ancho en pantallas más pequeñas */\n        max-width: 100% !important;\n        /* Límite de ancho máximo de las cajas */\n    }\n\n    .terms {\n        margin-left: 0 !important;\n    }\n\n    .buttonflex {\n        margin-left: 0 !important;\n    }\n\n    .marginCantitad {\n        margin-left: 0 !important;\n    }\n\n    .popularBlockchain {\n        padding: 2px 10px 0px 10px !important;\n        top: -22px !important;\n        left: calc(50% - 68px) !important;\n    }\n\n    select {\n        margin-bottom: 10px;\n    }\n\n    .dataTransferencia {\n        padding: 0px 0px 50px 5px;\n    }\n\n    .iban {\n        padding-top: 23px;\n    }\n\n    .dataDisplay{\n        gap: 20px;\n    }\n\n    .form-control{\n        font-size: 11px;\n    }\n\n    .cardImageContainerModal{\n        width: 100%;\n        padding-bottom: 0 !important;\n        background-color: #F5F5F5;\n        border: 3px solid #f09502;\n        margin-bottom: 30px;\n        border-radius: 15px !important;\n    }\n\n    .no-mobile {\n        display: none !important;\n    }\n\n    h5{\n        font-size: 0.85rem !important;\n    }\n\n    .popular{\n        left: calc(50% - 50px) !important;\n    }\n}\n\n@media (min-width: 656px) {\n    .options-mobile{\n        display: none\n    }\n}\n\n\n\n.flexContainer {\n    display: flex;\n}\n\n.colorDark {\n    background-color: #181b25;\n}\n\n.colorWhite {\n    background-color: white;\n}\n\n.paddingModalBody {\n    padding: 0 !important;\n}\n\n.cardContainer {\n    margin-top: 4rem;\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n\n.btnClose {\n    background-color: transparent;\n    color: white;\n    border: none;\n    font-size: 15px;\n}\n\n.btnContainer {\n    margin-top: 2rem;\n}\n\nmdb-tab {\n    color: black !important;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    color: #FF9600;\n    border: none;\n    border-bottom: 1px solid;\n}\n\n.nav-link {\n    color: black;\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.dai {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.iQuestion {\n    color: gray;\n    font-size: 24px;\n    margin-top: -4px;\n}\n\np,\nlabel {\n    color: #848484;\n}\n\n.marginCantitad {\n    display: flex;\n    gap: 15px;\n    margin-left: -2.3rem;\n}\n\n.priceData {\n    display: flex;\n    justify-content: space-between;\n    margin: 10px 120px 10px 85px;\n}\n\n.containerBox {\n    display: flex;\n    flex-wrap: wrap;\n    /* Permite que los elementos se envuelvan cuando no haya suficiente espacio en una línea */\n}\n\n.box {\n    border: 3px solid #FF9600;\n    padding: 5px 5px 5px 5px;\n    margin-right: 15px;\n    margin-bottom: 15px;\n    cursor: pointer;\n    border-radius: 20px;\n    max-width: 250px;\n    position: relative;\n    flex: 1;\n}\n\n.box.active {\n    background-color: rgba(255, 150, 0, 0.2);\n}\n\n\n.popular {\n    position: absolute;\n    border: 3px solid #FF9600;\n    background: white;\n    border-radius: 25px;\n    padding: 2px 10px 0px 10px;\n    top: -24px;\n    left: calc(50% - 68px);\n}\n\n.divPersonalizar {\n    display: flex;\n    align-items: center;\n}\n\n.personalizar {\n    color: black;\n    text-decoration: underline;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n\n.form-control:focus {\n    outline-color: #FF9600;\n}\n\n.navMargin {\n    margin: 70px 10px 30px 80px;\n    margin-top: 7rem;\n}\n\n\n.tool {\n    cursor: help;\n    position: relative;\n}\n\n.tool::before,\n.tool::after {\n    top: 50%;\n    opacity: 0;\n    position: absolute;\n    z-index: -100;\n}\n\n.tool:hover::before,\n.tool:focus::before,\n.tool:hover::after,\n.tool:focus::after {\n    opacity: 1;\n    transform: scale(1) translateX(0);\n    z-index: 100;\n    margin-left: 1rem;\n}\n\n.tool:hover::before,\n.tool:focus::before {\n    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;\n}\n\n.tool::after {\n    background: #3E474F;\n    border-radius: .25em;\n    color: #EDEFF0;\n    content: attr(data-tip);\n    margin-top: -2.5em;\n    padding: 1em;\n    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;\n    transform: scale(.6) translateX(50%);\n    width: 20em;\n}\n\n.tool:hover::after,\n.tool:focus::after {\n    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);\n}\n\n@media (max-width: 1060px) {\n    .tool::after {\n        font-size: .95em;\n        margin-top: -15.5em;\n        width: 28em;\n        right: 27%;\n        margin-top: -2px;\n        transform: translate(-50%, -50%);\n    }\n}\n\n@media (max-width: 760px) {\n    .tool::after {\n        font-size: .75em;\n    }\n}\n\n\n\n/*tooltip Box*/\n.con-tooltip {\n    position: relative;\n    display: inline-block;\n    cursor: help;\n\n}\n\n/*tooltip */\n.tooltip {\n    visibility: hidden;\n    z-index: 1;\n    position: absolute;\n    top: -140%;\n    left: -25%;\n    background: #3E474F;\n    border-radius: .25em;\n    color: #EDEFF0;\n    padding: 1em;\n    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;\n    transform: scale(.6) translateX(50%);\n    width: 20em;\n}\n\n\n\n.con-tooltip:hover .tooltip {\n    visibility: visible;\n    transform: translateY(-10px);\n    opacity: 1;\n}\n\n\n.right .tooltip {\n    top: 150%;\n    left: -800%;\n}\n\n.right .tooltip::after {\n    top: 150%;\n    left: -800%;\n    transform: rotate(90deg);\n}\n\n.circle {\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    background: #292929;\n    color: white;\n}\n\n.terms {\n    display: flex;\n    gap: 10px;\n    margin-left: -2.2rem;\n}\n\n\n.buttonflex {\n    display: flex;\n    gap: 10px;\n    margin-left: -2.2rem;\n    margin-top: 1rem;\n    align-items: center;\n}\n\n.popularBlockchain {\n    position: absolute;\n    border: 3px solid #FF9600;\n    background: white;\n    border-radius: 25px;\n    padding: 2px 10px 0px 10px;\n    top: -22px;\n    left: calc(50% - 68px);\n}\n\n.sizeTitle {\n    font-weight: 600;\n}\n\n\nselect {\n    border: 1px solid white !important;\n}\n\n@media screen and (max-width: 600px) {\n    #amountBuyTransferencia::placeholder {\n      font-size: 9px;\n    }\n  }\n\n  .header-modal-wallet{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    background: #FF9600;\n    font-size: 19px;\n    color: white;\n    border-radius: 50px;\n    padding: 8px;\n  }\n\n  /* Ocultar la wallet completa en dispositivos móviles */\n@media (max-width: 768px) {\n    .full-wallet {\n      display: none;\n    }\n    .short-wallet {\n      display: inline;\n    }\n    .header-modal-wallet{\n      font-size: 13px;\n    }\n  }\n\n  /* Mostrar la wallet completa en dispositivos de escritorio */\n  @media (min-width: 769px) {\n    .full-wallet {\n      display: inline;\n    }\n    .short-wallet {\n      display: none;\n    }\n  }\n\n  @media (max-width: 1450px) and (min-width: 500px) {\n    .small-text {\n      font-size: 0.85rem !important; /* Ajusta el tamaño según tus necesidades */\n    }\n  }\n\n.progress-bar {\n  background: linear-gradient(90deg, #ff9500 0%, #ffb84d 100%) !important;\n  border-radius: 20px;\n}\n\n/* Nuevos estilos para el diseño actualizado */\n.project-header {\n  width: 100%;\n}\n\n.project-title {\n  font-size: 1.35rem !important;\n  font-weight: 600 !important;\n  color: #000 !important;\n  margin: 0 !important;\n  margin-bottom: 12px !important;\n  line-height: 1.2 !important;\n}\n\n/* Selectores más específicos para sobrescribir Bootstrap h2 */\n.card .card-body .project-title,\n.card .project-header .project-title,\n.card .project-header h2.project-title,\n.card-body .project-header h2.project-title {\n  font-size: 1.35rem !important;\n  font-weight: 600 !important;\n  margin-bottom: 12px !important;\n}\n\n.project-address {\n  font-size: 0.95rem;\n  color: #000;\n  margin: 0;\n}\n\n.project-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.badge-pill {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.badge-type {\n  background: linear-gradient(to right, #ccffd7 0%, #e8f8ed 100%);\n  color: #000;\n}\n\n.badge-code {\n  background-color: #e0e0e0;\n  color: #000;\n}\n\n/* Nuevo formato de financiación */\n.pdata-new {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.finance-label {\n  font-size: 0.85rem;\n  color: #666;\n  margin: 0 0 4px 0;\n}\n\n.finance-amount {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #000;\n  margin: 0;\n}\n\n/* Detalles del proyecto */\n.project-details {\n  width: 100%;\n}\n\n.detail-item {\n  font-size: 0.95rem;\n  color: #000;\n  margin: 0 0 8px 0;\n}\n\n.detail-value {\n  font-weight: bold;\n}\n\n/* Badge de estado en la imagen */\n.status-badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: white;\n  z-index: 10;\n}\n\n.badge-venta-privada {\n  background-color: #a2cb6c;\n}\n\n.badge-en-estudio {\n  background-color: #FA629C;\n}\n\n.badge-gestionando {\n  background-color: #a2cb6c;\n}\n\n.badge-activo {\n  background-color: #a2cb6c;\n}\n\n.badge-financiado {\n  background-color: #848484;\n}\n\n.badge-en-curso {\n  background-color: #6941C6 !important;\n}\n\n.badge-dividendos {\n  background-color: #6EC8CA;\n}\n\n.badge-vendido {\n  background-color: #0093A2;\n}\n\n/* Botones nuevos */\n.btn-invest {\n  background: linear-gradient(to right, #fea11b 0%, #ffc266 100%);\n  color: white;\n  border: none;\n  border-radius: 25px;\n  padding: 6px 20px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.btn-invest:hover:not(:disabled) {\n  background: linear-gradient(to right, #fea11b 0%, #ffc266 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(254, 161, 27, 0.3);\n}\n\n.btn-invest:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-know-more {\n  background: linear-gradient(to right, #d1c7c6 0%, #d5cdcc 100%);\n  color: white;\n  border: none;\n  border-radius: 25px;\n  padding: 6px 20px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.btn-know-more:hover:not(:disabled) {\n  background: linear-gradient(to right, #c4b8b7 0%, #c8c0bf 100%);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-know-more:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Ajustes para el contenedor de botones */\n.containerButtons {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.containerButtons .btn {\n  flex: 1;\n  margin-bottom: 0 !important;\n}\n\n.containerButtons .btn.w-100 {\n  flex: 1 1 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
